import {CompatClient, Stomp} from "@stomp/stompjs";
import {EventIntf} from "./ServerTypes";

interface StatusMessage {
    enabled: boolean
    reason: string
}

export default class ConferenceGameConnection {
    stompClient: CompatClient

    constructor() {

        let url = `${process.env.REACT_APP_GAME_CALL_WS}/gs-guide-websocket`;
        this.stompClient = Stomp.client(url)
        this.stompClient.reconnect_delay = 5000
        this.stompClient.debug = function () {
        };
    }

    connect(event: EventIntf, userId: number, onEnabledChange: (enabled: boolean) => void, onRefeshData: () => void) {
        const headers = {
            type: "main",
            eventId: event.id,
            userId: userId
        }
        this.stompClient.connect(headers, (frame: any) => {
            this.stompClient!.subscribe('/user/topic/playingStatus/' + event.id,
                (msg) => {
                    let statusMessage = JSON.parse(msg.body) as StatusMessage
                    onEnabledChange(statusMessage.enabled)
                    if (!statusMessage.enabled) {
                        this.stompClient!.disconnect()
                    }
                })

            this.stompClient!.subscribe('/topic/dataUpdate/' + event.id,
                (msg) => {
                    onRefeshData()
                })

            this.stompClient!.send("/app/connectionMain", headers, "connect")

            onRefeshData()
        });
    }
}
